import { CardMemoryGame, blackSuits, redSuits } from '../cards'

class Pairs3By4Exercise extends CardMemoryGame {
  constructor (_wrapper) {
    const suits = [redSuits[Math.round(Math.random())], blackSuits[Math.round(Math.random())]]
    super({ cardsPerFaceValue: 2, totalCards: 12, suits })
  }

  _timeSpentPenalty () {
    const allTries = [
      ...[...this.cardsContainer.querySelectorAll('div')]
        .map((card) => card.dataset.tries)
        .filter((tries) => tries !== undefined)
        .flatMap((tries) =>
          tries.split('|').filter((timestamp) => timestamp !== '')
        )
    ].sort()

    const secondsSpent =
      (parseInt(allTries.at(-1), 10) - parseInt(allTries.at(0), 10)) / 1000
    // min = 10 seconds (and below) = 0 points penalty as you've rushed it
    // max = 50 seconds (and above) = 50 points penalty as you're a snail
    const minPenalty = 0
    const maxPenalty = 50
    const rushedSeconds = 10
    const slowSeconds = 50
    if (secondsSpent <= rushedSeconds) return minPenalty
    if (secondsSpent >= slowSeconds) return maxPenalty

    return (
      ((secondsSpent - rushedSeconds) * maxPenalty) /
      (slowSeconds - rushedSeconds)
    )
  }
}

const twelveCards = document.querySelector('body.twelve-cards-pairs')
if (twelveCards !== null) {
  // const exerciseWrapper = document.querySelector('#js-12-cards-container')
  const exercise = new Pairs3By4Exercise()
  window.exercises = exercise
  exercise.prepare()
}
